var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_10416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.898L16.95 15.948C17.9289 14.969 18.5955 13.7217 18.8656 12.3638C19.1356 11.006 18.9969 9.59857 18.4671 8.31952C17.9373 7.04048 17.04 5.94728 15.8889 5.17814C14.7378 4.409 13.3844 3.99847 12 3.99847C10.6156 3.99847 9.26222 4.409 8.11109 5.17814C6.95996 5.94728 6.06275 7.04048 5.53292 8.31952C5.00308 9.59857 4.86442 11.006 5.13445 12.3638C5.40449 13.7217 6.07111 14.969 7.05 15.948L12 20.898ZM12 23.726L5.636 17.362C4.37734 16.1033 3.52019 14.4996 3.17293 12.7538C2.82567 11.008 3.00391 9.1984 3.6851 7.55387C4.36629 5.90934 5.51984 4.50374 6.99988 3.51481C8.47992 2.52588 10.22 1.99805 12 1.99805C13.78 1.99805 15.5201 2.52588 17.0001 3.51481C18.4802 4.50374 19.6337 5.90934 20.3149 7.55387C20.9961 9.1984 21.1743 11.008 20.8271 12.7538C20.4798 14.4996 19.6227 16.1033 18.364 17.362L12 23.726ZM12 12.998C12.5304 12.998 13.0391 12.7873 13.4142 12.4122C13.7893 12.0371 14 11.5284 14 10.998C14 10.4675 13.7893 9.95883 13.4142 9.58376C13.0391 9.20868 12.5304 8.99797 12 8.99797C11.4696 8.99797 10.9609 9.20868 10.5858 9.58376C10.2107 9.95883 10 10.4675 10 10.998C10 11.5284 10.2107 12.0371 10.5858 12.4122C10.9609 12.7873 11.4696 12.998 12 12.998ZM12 14.998C10.9391 14.998 9.92172 14.5765 9.17158 13.8264C8.42143 13.0763 8 12.0588 8 10.998C8 9.9371 8.42143 8.91969 9.17158 8.16954C9.92172 7.4194 10.9391 6.99797 12 6.99797C13.0609 6.99797 14.0783 7.4194 14.8284 8.16954C15.5786 8.91969 16 9.9371 16 10.998C16 12.0588 15.5786 13.0763 14.8284 13.8264C14.0783 14.5765 13.0609 14.998 12 14.998Z",
    fill: "url(#paint0_linear_12_10416)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_10416",
    x1: -17.5714,
    y1: 12.862,
    x2: 15.8571,
    y2: 12.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_10416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemGps);
export default __webpack_public_path__ + "static/media/itemGps.e3238cc88353445874aaa5794ada86e4.svg";
export { ForwardRef as ReactComponent };